export default __webpack_public_path__ + "static/media/Anil.48602a46.png";